import * as React from 'react';
export const truistSvg = React.forwardRef(function truistSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#2E1A47',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M24.318 24.318v-7.347h-5.077v3.641h-1.943v-9.224h1.943v3.64h5.077V7.683H7.682v7.347h5.077v-3.641h1.943v9.224h-1.943v-3.64H7.682v7.346h16.636ZM6 24.171V7.83C6 6.686 6.686 6 7.829 6H24.17C25.314 6 26 6.686 26 7.829V24.17c0 1.144-.686 1.83-1.83 1.83H7.83C6.686 26 6 25.314 6 24.171Z',
      fill: '#fff',
    }),
  );
});
truistSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var truist = {
  category: 'brand',
  colorable: false,
  name: 'truist',
  svg: truistSvg,
};
